import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { QuillViewComponent as QuillViewComponent_1 } from 'ngx-quill';
@Component({
    selector: 'app-quill-view',
    templateUrl: './quill-view.component.html',
    styleUrls: ['./quill-view.component.scss'],
    standalone: true,
    imports: [QuillViewComponent_1]
})
/** *Quill View Component*/
export class QuillViewComponent implements OnInit {
	@Input() quillContent: any | undefined;
	sanitizedContent: string = '';
	constructor(public sanitizer: DomSanitizer) {}

	ngOnInit(): void {}


	ngOnChanges(): void {
		if (this.quillContent) {
		  this.sanitizedContent = this.sanitizer.sanitize(SecurityContext.HTML, this.quillContent) || '';
		}
	  }
	getContent(content: any) {
		let trustedContent = this.sanitizer.bypassSecurityTrustHtml(content);
		return trustedContent;
	}
}
